import classNames from "classnames";
import React from "react";
import { Control, MapProps } from "react-redux-form";

interface Props {
  model: string;
  id: string;
  className?: string;

  /** Defaults to model */
  name?: string;
  disabled?: boolean;
  value: string|number;
  label: string|JSX.Element;
  subLabel?: string|JSX.Element;
  getValue?: (e: string|React.ChangeEvent<HTMLInputElement>, props?: any) => any;
  onCheckedChange?: (isToggled: boolean) => void;
  validators?: { [validatorName: string]: (val: string) => boolean };
  mapProps?: MapProps;
}

/**
 * Convenience wrapper of RRF's Control.radio
 */
export class RadioButton extends React.Component<Props> {
  public render() {
    const { getValue, onCheckedChange, label, subLabel, children, className, ...radioProps } = this.props;

    return (
      <div className={classNames("rrf-radio-button", className)}>
        <Control.radio
          {...radioProps}
          getValue={e => getValue ? getValue(e) : (e as React.ChangeEvent<HTMLInputElement>).target.value}
          onChange={e => onCheckedChange && onCheckedChange((e.target as HTMLInputElement).checked)}
        />
        <label htmlFor={this.props.id}>
          {this.props.label}
          {this.props.subLabel && <p className="rrf-radio-button-sub-label">{this.props.subLabel}</p>}
        </label>

        {this.props.children}
      </div>
    );
  }
}
